// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Sr4A4","contentContainer":"styles_contentContainer__xQeGh"};